import React, { Component } from 'react'
import { Mutation, Query } from 'react-apollo'
import { Link } from 'react-router-dom'
import gql from 'graphql-tag'

import Loader from 'components/Loader'
import { Button, Container, Header, Table } from 'semantic-ui-react'

const Yes = () => <span style={{ color: 'green' }}>Yes</span>
const No = () => <span style={{ color: 'red' }}>No</span>

class Polls extends Component {
  state = {
    limit: 20,
    offset: 0,
  }

  handleDelete = fn => () => {
    const answer = window.confirm(
      'Are you sure you want to permanently remove this poll?',
    )
    if (answer) {
      fn()
    }
  }

  renderRow = poll => {
    const { limit, offset } = this.state
    const variables = { limit, offset }
    return (
      <Table.Row key={poll.id}>
        <Table.Cell width={8}>{poll.question}</Table.Cell>
        <Table.Cell width={4}>{poll.active ? <Yes /> : <No />}</Table.Cell>
        <Table.Cell width={4} style={{ display: 'flex' }}>
          <Link to={`/polls/edit/${poll.id}`}>
            <Button basic color="blue" content="Edit" />
          </Link>
          <Mutation
            mutation={PUBLISH_POLL}
            update={(cache, { data: { updatePoll } }) => {
              const { polls } = cache.readQuery({
                query: POLLS_QUERY,
                variables,
              })
              const indexToUpdate = polls.findIndex(p => p.id === poll.id)
              const data = {
                polls: [
                  ...polls.slice(0, indexToUpdate),
                  {
                    ...updatePoll,
                    active: !poll.active,
                  },
                  ...polls.slice(indexToUpdate + 1),
                ],
              }
              cache.writeQuery({
                query: POLLS_QUERY,
                data,
                variables,
              })
            }}
          >
            {(updatePoll, { data }) => (
              <Button
                basic
                color="orange"
                content={poll.active ? 'Unpublish' : 'Publish'}
                onClick={() =>
                  updatePoll({
                    variables: {
                      id: poll.id,
                      input: {
                        active: !poll.active,
                      },
                    },
                  })
                }
              />
            )}
          </Mutation>
          <Mutation
            mutation={DELETE_POLL}
            update={cache => {
              const { polls } = cache.readQuery({
                query: POLLS_QUERY,
                variables,
              })
              const data = {
                polls: polls.filter(p => p.id !== poll.id),
              }
              cache.writeQuery({
                query: POLLS_QUERY,
                data,
                variables,
              })
            }}
          >
            {(deletePoll, { data }) => (
              <Button
                basic
                color="red"
                content="Delete"
                onClick={this.handleDelete(() =>
                  deletePoll({ variables: { id: poll.id } }),
                )}
              />
            )}
          </Mutation>
        </Table.Cell>
      </Table.Row>
    )
  }

  renderTable() {
    const { limit, offset } = this.state
    const variables = { limit, offset }

    return (
      <Query query={POLLS_QUERY} variables={variables}>
        {({ data, loading, error, fetchMore }) => {
          if (loading) {
            return <Loader />
          }
          if (error) {
            console.error(error)
            return <div>an error has occurred</div>
          }

          return (
            <Table>
              <Table.Header>
                <Table.Row>
                  <Table.HeaderCell>Question</Table.HeaderCell>
                  <Table.HeaderCell>Published</Table.HeaderCell>
                  <Table.HeaderCell>Actions</Table.HeaderCell>
                </Table.Row>
              </Table.Header>

              <Table.Body>{data.polls.map(this.renderRow)}</Table.Body>
            </Table>
          )
        }}
      </Query>
    )
  }

  render() {
    return (
      <Container style={{ marginBottom: 32 }}>
        <Header as="h1">Polls/Quizzes</Header>

        <Button
          floated="right"
          primary
          size="small"
          content="Add Poll"
          onClick={() => this.props.history.push('/polls/new')}
        />

        {this.renderTable()}
      </Container>
    )
  }
}

export const POLLS_QUERY = gql`
  query PollsQuery($limit: Int, $offset: Int) {
    polls(limit: $limit, offset: $offset) {
      id
      question
      active
      created
      updated
    }
  }
`

const PUBLISH_POLL = gql`
  mutation UpdatePoll($id: ID!, $input: UpdatePollInput!) {
    updatePoll(id: $id, input: $input) {
      id
    }
  }
`

export const DELETE_POLL = gql`
  mutation DeletePoll($id: ID) {
    deletePoll(id: $id) {
      id
    }
  }
`

export default Polls
